import React from "react";
import { Card, CardContent, CardActions, Box, Typography, Chip, Button, IconButton, Tooltip, alpha } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineTwoToneIcon from "@mui/icons-material/DeleteOutlineTwoTone";
import CategoryIcon from "@mui/icons-material/Category";
import translations from "../../translations/productFamilyTranslation";

const ACCENT = "#1976d2";

const ProductFamilyCard = ({ pf, onEdit, onDelete }) => (
  <Card
    sx={{
      height: "100%",
      display: "flex",
      flexDirection: "column",
      borderRadius: 4,
      overflow: "hidden",
      border: `1px solid ${alpha("#000000", 0.06)}`,
      background: "linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      "&:hover": {
        boxShadow: "0 12px 32px rgba(0, 0, 0, 0.12)",
        transform: "translateY(-4px)",
        borderColor: alpha(ACCENT, 0.4),
      },
    }}
  >
    <Box
      sx={{
        background: `linear-gradient(135deg, ${alpha("#f8fafc", 0.8)} 0%, ${alpha(ACCENT, 0.08)} 100%)`,
        p: 2.5,
        borderBottom: `2px solid ${alpha(ACCENT, 0.12)}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1.5,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, minWidth: 0 }}>
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: "50%",
            bgcolor: alpha(ACCENT, 0.12),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <CategoryIcon sx={{ color: ACCENT }} />
        </Box>
        <Typography
          variant="h6"
          sx={{ fontWeight: 700, fontSize: "1.05rem", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
          title={pf.familyName}
        >
          {pf.familyName}
        </Typography>
      </Box>
      <Tooltip title={translations.deleteProductFamily}>
        <IconButton size="small" color="warning" onClick={() => onDelete(pf._id)}>
          <DeleteOutlineTwoToneIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>

    <CardContent sx={{ flexGrow: 1, display: "flex", flexDirection: "column", gap: 1.25 }}>
      <Typography variant="body2" color="text.secondary">
        {pf.familyDes}
      </Typography>
      <Chip label={pf.ft} size="small" variant="outlined" sx={{ alignSelf: "flex-start" }} />
      {pf.orderApprovalRequired && (
        <Chip
          label={`${translations.orderApprovalRequired}${pf.approverRole?.Name ? ` — ${pf.approverRole.Name}` : ""}`}
          size="small"
          sx={{ alignSelf: "flex-start", bgcolor: alpha(ACCENT, 0.08), color: ACCENT, fontWeight: 600 }}
        />
      )}
    </CardContent>

    <CardActions sx={{ px: 2.5, pb: 2.5, pt: 0 }}>
      <Button
        fullWidth
        variant="contained"
        size="small"
        startIcon={<EditOutlinedIcon />}
        onClick={() => onEdit(pf)}
        sx={{
          borderRadius: 2.5,
          textTransform: "none",
          fontWeight: 600,
          background: `linear-gradient(135deg, ${ACCENT} 0%, ${alpha(ACCENT, 0.85)} 100%)`,
        }}
      >
        {translations.edit}
      </Button>
    </CardActions>
  </Card>
);

export default ProductFamilyCard;
